import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField
} from '@mui/material'
import { getEmailValidationState } from '../../utils/email'
import css from './ModalEditarDatosEmail.module.css'

const ModalEditarDatosEmail = ({ open, emailsContacto, onSubmit, onClose }) => {
  const [emails, setEmails] = useState([])

  useEffect(() => {
    if (open) {
      const hasEmails = emailsContacto && emailsContacto.length > 0
      if (hasEmails) setEmails(emailsContacto)
      else setEmails([{ nombre: '', email: '', observaciones: '' }])
    }
  }, [open, emailsContacto])

  const handleSubmit = () => onSubmit(emails)

  const isSubmitDisabled = emails.some(
    e => getEmailValidationState(e) === 'error'
  )

  const handleAddEmail = () => {
    setEmails([...emails, { nombre: '', email: '', observaciones: '' }])
  }

  const handleRemoveEmail = index => {
    const newEmails = emails.filter((_, i) => i !== index)
    setEmails(newEmails)
  }

  const handleUpdateEmail = (index, field, value) => {
    const newEmails = [...emails]
    newEmails[index] = {
      ...newEmails[index],
      [field]: value
    }
    setEmails(newEmails)
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Editar emails</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.content}>
          <div className={css.container}>
            {emails.map((email, index) => {
              const status = getEmailValidationState(email)
              return (
                <div key={index} className={css.row}>
                  <div className={css.inputsContainer}>
                    <TextField
                      name={`nombre-${index}`}
                      className={css.contactoInput}
                      label='Nombre'
                      type='text'
                      variant='standard'
                      value={email.nombre}
                      onChange={e =>
                        handleUpdateEmail(index, 'nombre', e.target.value)
                      }
                    />
                    <TextField
                      name={`email-${index}`}
                      className={css.emailInput}
                      label='Email'
                      type='email'
                      variant='standard'
                      value={email.email}
                      onChange={e =>
                        handleUpdateEmail(index, 'email', e.target.value)
                      }
                    />
                  </div>
                  <div className={css.actions}>
                    <IconButton
                      className={css.removeButton}
                      onClick={() => handleRemoveEmail(index)}
                      size='small'
                      color='error'
                    >
                      <span className='material-icons'>delete</span>
                    </IconButton>
                    <span
                      className={`material-icons ${css.icon}`}
                      data-status={status}
                    >
                      {status === 'success' && 'check_circle'}
                      {status === 'warning' && 'warning'}
                      {status === 'error' && 'error'}
                    </span>
                  </div>
                </div>
              )
            })}
            <Button
              className={css.addButton}
              variant='outlined'
              color='primary'
              onClick={handleAddEmail}
              startIcon={<span className='material-icons'>add</span>}
            >
              Añadir email
            </Button>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          color='primary'
          onClick={handleSubmit}
          disabled={isSubmitDisabled}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarDatosEmail
